import React, { useState } from "react";
import { CheckoutStoreContext, createCheckoutStore } from "./use-checkout-store";

interface CheckoutStoreProviderProps {
  children: React.ReactNode;
}

export const CheckoutStoreProvider: React.FC<CheckoutStoreProviderProps> = ({ children }) => {
  // Lazy initializer ensures the store is created exactly once per provider
  // instance, even under React Strict Mode.
  const [store] = useState(() => createCheckoutStore());

  return <CheckoutStoreContext.Provider value={store}>{children}</CheckoutStoreContext.Provider>;
};
